import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { Hero } from 'shared/layout/Hero'
import { Heading } from 'ui/typography'
import { Container } from 'components/layout'
import { Box, Stack } from 'ui/primitives'
import { RichTextArea } from 'experiences/shared/RichTextArea'

export const Providers = () => {
	const pageResources = useContentfulResourcesMapped()

	return (
		<>
			<Hero>
				<Heading.H1>{ResourceUtils(pageResources['providers.title']).getPlainTextContent()}</Heading.H1>
			</Hero>
			<Container>
				<Box paddingY="xxl">
					<Stack gap="xl">
						<Heading.H2>{ResourceUtils(pageResources['providers.disclaimer']).getPlainTextContent()}</Heading.H2>
						<RichTextArea document={ResourceUtils(pageResources['providers.list']).getRichContent()} />
					</Stack>
				</Box>
			</Container>
		</>
	)
}
